import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ProviderClientStatusHistoryModel from "../../models/provider-client-status-history";

export default class ProviderClientStatusHistoryRepository extends BaseRepository {
  static modelClass = ProviderClientStatusHistoryModel;
  modelName = "provider-client-status-history";

  async query({ providerClientStatusId }) {
    if (!providerClientStatusId) {
      throw new Error("providerClientStatusId is required to fetch the history.");
    }

    return await super.query({
      urlPath: `pro_cli_status/${providerClientStatusId}/history`,
    });
  }
}
